import type {
	Count,
	DeploymentFrequencyReportWithProviderInfo,
	DeploymentFrequencyReportWeekData,
} from '../../../common/types';
import { getSelectedWeekData } from '../../../controllers/selected-date-range/utils';
import {
	isDataAbsolutelyEmpty as getIsDataAbsolutelyEmpty,
	isDataUnmappedFoundWithMissingProd as getIsDataUnmappedFoundWithMissingProd,
	isDevelopmentDataEmpty as getIsDevelopmentDataEmpty,
	isProdDataEmpty as getIsProdDataEmpty,
	isStagingDataEmpty as getisStagingDataEmpty,
	isTestingDataEmpty as getIsTestingDataEmpty,
	isUnmappedDataEmpty as getIsUnmappedDataEmpty,
} from '../../../services/deployment-frequency-core/utils';

type PotentialCount = Count | '-' | undefined;
type PotentialCountByEnv = {
	developmentCount: PotentialCount;
	testingCount: PotentialCount;
	stagingCount: PotentialCount;
	productionCount: PotentialCount;
	unmappedCount: PotentialCount;
};

const getPotentialCount = (
	isDataAbsolutelyEmpty: boolean,
	isEnvironmentDataEmpty: boolean,
	isDataUnmappedFoundWithMissingProd: boolean,
	count: Count,
): PotentialCount => {
	if (isDataAbsolutelyEmpty) {
		return 0;
	}

	if (isDataUnmappedFoundWithMissingProd && isEnvironmentDataEmpty) {
		return '-';
	}

	return isEnvironmentDataEmpty ? undefined : count;
};

export const getPotentialCounts = (
	reportData: DeploymentFrequencyReportWithProviderInfo,
	selectedWeekStart: Date,
): PotentialCountByEnv => {
	const isDataAbsolutelyEmpty = getIsDataAbsolutelyEmpty(reportData);
	const isDevelopmentDataEmpty = getIsDevelopmentDataEmpty(reportData);
	const isTestingDataEmpty = getIsTestingDataEmpty(reportData);
	const isStagingDataEmpty = getisStagingDataEmpty(reportData);
	const isProdDataEmpty = getIsProdDataEmpty(reportData);
	const isUnmappedDataEmpty = getIsUnmappedDataEmpty(reportData);
	const isDataUnmappedFoundWithMissingProd = getIsDataUnmappedFoundWithMissingProd(reportData);
	const selectedWeekData: DeploymentFrequencyReportWeekData = getSelectedWeekData(
		reportData.weeksData,
		selectedWeekStart,
	);

	return {
		developmentCount: getPotentialCount(
			isDataAbsolutelyEmpty,
			isDevelopmentDataEmpty,
			isDataUnmappedFoundWithMissingProd,
			selectedWeekData.deploymentCount.development,
		),
		testingCount: getPotentialCount(
			isDataAbsolutelyEmpty,
			isTestingDataEmpty,
			isDataUnmappedFoundWithMissingProd,
			selectedWeekData.deploymentCount.testing,
		),
		stagingCount: getPotentialCount(
			isDataAbsolutelyEmpty,
			isStagingDataEmpty,
			isDataUnmappedFoundWithMissingProd,
			selectedWeekData.deploymentCount.staging,
		),
		productionCount: getPotentialCount(
			isDataAbsolutelyEmpty,
			isProdDataEmpty,
			isDataUnmappedFoundWithMissingProd,
			selectedWeekData.deploymentCount.prod,
		),
		unmappedCount: getPotentialCount(
			isDataAbsolutelyEmpty,
			isUnmappedDataEmpty,
			isDataUnmappedFoundWithMissingProd,
			selectedWeekData.deploymentCount.unmapped,
		),
	};
};
